import { ActionReducer, MetaReducer } from '@ngrx/store';
import { LOGOUT_POST } from '../action-types';
import { IAppState, initialAppState } from './app-state';
import { initialSessionState } from '../session/session-state';
import { initialAuthState } from '../auth/auth-state';
import { StateSlice } from '../state-slice';
import { environment } from '@environments/environment';

export function rootMetaReducer(reducer: any): ActionReducer<any> {
    return (state: any, action: any) => {

        switch (action.type) {
            case LOGOUT_POST:

                // Clear state but persist global and preference slice
                let freshState: IAppState = Object.assign({...initialAppState()}, {
                    session: initialSessionState(),
                    auth: initialAuthState()
                });

                delete freshState['global'];
                delete freshState['preference'];

                state = {
                    global: state.global,
                    preference: state.preference,
                    ...freshState
                };

                break;

            default:
                break;
        }

        return reducer(state, action, state[StateSlice.ENTITY]);
    };
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<any, any>[] = !environment.production
  ? [rootMetaReducer]
  : [rootMetaReducer];